import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { ThemeProvider } from 'styled-components';
import { ErrorBoundary } from 'react-error-boundary';

import './i18n';
import './index.css';
import initStore from './store';
import theme from './theme.json';
import App from './App';
import ErrorFallback from './UnhandledErrorFallback';

import { unregister as unregisterServiceWorker } from './registerServiceWorker';
import refParser from 'json-schema-ref-parser';

async function renderCore() {
  const resolvedTheme = await refParser.dereference(theme);
  const app = (
    <Provider store={initStore()}>
      <BrowserRouter getUserConfirmation={() => {}}>
        <ThemeProvider theme={resolvedTheme}>
          <ErrorBoundary FallbackComponent={ErrorFallback}>
            <App />
          </ErrorBoundary>
        </ThemeProvider>
      </BrowserRouter>
    </Provider>
  );

  ReactDOM.render(app, document.getElementById('root'));

  // The app used to register CRA's precaching service worker, which served navigations from its own
  // cache -- so a deploy never reached anyone: the worker answered before the network was consulted
  // (nginx cache headers were moot, and a hard refresh did not help), and CRA1's helper never calls
  // skipWaiting(), so an updated worker waited until the user closed EVERY tab of the site. This app
  // has no offline requirement, so there is nothing to trade away by dropping it.
  // The old worker is torn down on existing clients by sw-killswitch.js, which replaces the
  // generated service-worker.js at build time (see the Dockerfile).
  unregisterServiceWorker();
}

renderCore();
